"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const solid_client_authn_core_1 = require("@inrupt/solid-client-authn-core");
class SecondaryDeviceOidcHandler {
    async canHandle(oidcLoginOptions) {
        return false;
    }
    async handle(oidcLoginOptions) {
        throw new solid_client_authn_core_1.NotImplementedError("SecondaryDeviceOidcHandler handle");
    }
}
exports.default = SecondaryDeviceOidcHandler;
//# sourceMappingURL=SecondaryDeviceOidcHandler.js.map